"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mobile = {};

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      fontControl = _a.fontControl,
      paddingControlHorizontal = _a.paddingControlHorizontal,
      sizeControlHeight = _a.sizeControlHeight,
      sizeBorderRadius = _a.sizeBorderRadius,
      x5 = _a.x5,
      colorText = _a.colorText,
      colorBgPopup = _a.colorBgPopup;
  return __assign(__assign({
    base: __assign(__assign({
      display: 'block',
      fontFamily: fontFamily,
      backgroundColor: colorBgPopup.normal,
      color: colorText.normal,
      border: 'none',
      borderRadius: sizeBorderRadius,
      padding: (sizeControlHeight - x5) / 2 + "px " + paddingControlHorizontal + "px",
      height: sizeControlHeight + x5 + "px",
      boxSizing: 'border-box',
      width: '100%',
      margin: 0
    }, fontControl), {
      '&:focus, &$focus': {
        outline: 'none'
      }
    }),
    fit: {
      height: '100%'
    }
  }, mobileStylesHelper_1.default(mobile)), {
    hover: {},
    focus: {}
  });
};